import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Contexts/AuthContext/AuthProvider';


const LoginRoute = ({ children }) => {

    const { authUser } = useContext(AuthContext);
    const location = useLocation();


    if (authUser?.role === "admin") {
        return (
            <Navigate
                to="/admin/dashboard"
                state={{ from: location }}
                replace
            />
        );
    }

    if (authUser?.role === "agent") {
        return (
            <Navigate
                to="/agent/dashboard"
                state={{ from: location }}
                replace
            />
        );
    }

    return children;

}

export default LoginRoute;